wbApp.directive('wbActivityTariffsCombo', ['$timeout', '$translate', '$filter', 'activityTariffSvc',
    function ($timeout, $translate, $filter, activityTariffSvc) {
        function formatResult(tariff) {
            if (!tariff) { return; }

           // return tariff.name;

            return "<div class='row'>" +
                        "<div class='col-md-8'>" + tariff.name + "</div>" +
                        "<div class='col-md-4' style='text-align:right;' >" + $filter('wbCurrencyFlt')(tariff.price) + "</div>" +
                    "</div>";
        }

        function formatSelection(tariff) {
            return tariff.name + ' (' + $filter('wbCurrencyFlt')(tariff.price) + ')';
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            link: function (scope, elm, attrs, ctrl) {
                
                var models = activityTariffSvc.getAllNonDeletedAsync(false, scope.ngModel);

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_ACTIVITY_TARIFF'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        id: function (model) { return model.activityTariffID; },
                        data: models
                    });

                    ctrl.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    ctrl.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    ctrl.$render = function () {
                        if (models.$promise) {
                            models.$promise.then(function () {
                                $(elm).select2('val', ctrl.$viewValue);
                            });
                        }
                    }

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                }, 1);
            }
        }
    }]);